import { RECEIVE_ENTITIES, RECEIVE_GROUPING_LEVELS, REQUEST_ENTITIES, REQUEST_GROUPING_LEVELS, REQUEST_BUCKET_LEVELS, RECEIVE_BUCKET_LEVELS } from "./actionTypes";
import { fetchGroupingLevels } from "@ls/grouping-service";
import { fetchEntityAttributes } from '@ls/entity-service';

import { exchange } from '@ls/js-fetch';

export function requestGroupingLevels() {
  return async (dispatch) => {
    dispatch({ type: REQUEST_GROUPING_LEVELS });
    dispatch({
      type: RECEIVE_GROUPING_LEVELS,
      data: await fetchGroupingLevels(),
    });
  }
}

export function requestISBucketLevels() {
  return async (dispatch) => {
    dispatch({ type: REQUEST_BUCKET_LEVELS });
    console.log(123)
    dispatch({
      type: RECEIVE_BUCKET_LEVELS,
      data: await fetchIsBucketLevels(),
    });
  }
}

const fetchIsBucketLevels = async () => {
  return await exchange({
    baseURL: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
    url: 'levels?appName=' + process.env.REACT_APP_ID,
  });

}

export const requestEntities = (asOfDate) => {
  return async (dispatch) => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {
      entityDates: asOfDate,
      select: 'entityId,name,benchmarkId,type,currency,minor,major,longName,code,acId',
      relative: false,
      lookthru: false,
    };

    const group_type = searchParams.get('group_type');
    const identifier = searchParams.get('identifier');

    if (group_type?.length) {
      params.entityIdsType = group_type; //to keep it consistent with Jim's expectations, which are group_type and identifier parameters
    }
    if (identifier?.length) {
      params.entityIds = identifier;
    }
    dispatch({ type: REQUEST_ENTITIES });
    dispatch({
      type: RECEIVE_ENTITIES,
      data: await fetchEntityAttributes(params),
    });
  }
};